<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div class="main-title-wrap">
        <!--        <a-form-model>-->
        <div style="text-align: right">
          <a-button @click="add()" type="link" v-has="'WARNING_REASON_ADD'">
            添加
          </a-button>
        </div>

        <!--        </a-form-model>-->

      </div>
      <div class="main-content-wrap">
        <a-row>
          <a-col :span="24">
            <a-table :data-source="tableData" :pagination="false" style="width: 100%">
              <a-table-column align="center" data-index="reason" title="预警原因" width="">
              </a-table-column>
              <a-table-column align="center" data-index="createAt" title="创建时间" width="">
              </a-table-column>
              <a-table-column align="center" data-index="updatedAt" title="更新时间" width="">
              </a-table-column>
              <a-table-column align="center" title="操作" width="350">
                <template slot-scope="text, record">
                  <a-button @click="edit(record)" type="link" v-has="'WARNING_REASON_EDIT'" size="small">编辑</a-button>
                  <span class="spanCss" v-has="'WARNING_REASON_DELETE'">|</span>
                  <a-button @click="del(record.id)" type="link" v-has="'WARNING_REASON_DELETE'" size="small"
                            class="operationBtn">删除
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-modal v-model="form.visible" width="600px" @cancel="onFormCancel" @ok="onFormSave">
      <warn-reason-edit :get-list="getList" :warn-reason-id="form.data.warnReasonId" ref="warningReason"></warn-reason-edit>
    </a-modal>

  </a-card>
</template>

<script>
import {getWarnReasonList, delWarnReason} from '../../../api/warnReson';
import WarnReasonEdit from './WarnReasonEdit';
import {getTime} from '../../../utils/dateUtil'
import {_deleteBizCompany} from "../../../api/bizCompanyApi";


/**
 * 初始化列表数据
 */
async function getList() {
  const result = await getWarnReasonList();
  if (result.code === 1200) {
    // this.tableData = result.data.warnReasons;
    this.$set(this, 'tableData', result.data.warnReasons)
  }
}

function onFormSave() {
  this.form.visible = false;
  this.$refs.warningReason.save();
  // await this.getList();
  this.form.data = {};
}


function onFormCancel() {
  this.form.visible = false;
  // this.$refs.warningReason.cancel();
  this.getList();
  this.form.data = {};
}

function edit(record) {
  this.form.data.warnReasonId = record.id;
  this.form.visible = true;
}

function add() {
  this.form.data.warnReasonId = '';
  this.form.visible = true;
}

function del(id) {
  let that = this;
  this.$confirm({
    title: '是否删除这条数据?',
    content: '',
    okType: 'danger',
    async onOk() {
      const result = await delWarnReason(id);
      if (result.code === 1200) {
        that.$message.success('删除成功')
        that.form.data = {};
        await that.getList();
      }
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });
}

export default {
  components: {
    WarnReasonEdit,
  },
  methods: {
    getList,
    onFormSave,
    onFormCancel,
    edit,
    add,
    del,
  },
  created() {
    this.getList();
  },
  data() {
    return {
      tableData: [],
      form: {
        visible: false,
        data: {
          warnReasonId: '',
        },
      },
    };
  },
};
</script>
